import { render, staticRenderFns } from "./SynaqService.vue?vue&type=template&id=0eee0332&scoped=true&"
import script from "./SynaqService.vue?vue&type=script&lang=js&"
export * from "./SynaqService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eee0332",
  null
  
)

export default component.exports